import { RouteConfig } from 'vue-router';
import MachineTimeline from './pages/MachineTimeline.vue';

export default [
    {
        path: '/:tenantId/machine-timeline',
        name: 'MachineTimeline',
        component: MachineTimeline,
        props: (route) => ({ tenantId: route.params.tenantId }),
        meta: {
            checkLicence: true,
            title: 'menu.machineTimeline',
        },
    },
] as RouteConfig[];

